import { css } from "styled-components"

/**
 * A shortcut for conditionally applying a style to the styled component, based on whether
 * a specific property has a falsy value.
 * @param {string} propName the name of property to check for falsy value.
 * @returns {function} a function that conditionally applies css.
 */
const unless = propName => (...args) => css`
  ${props => !props[propName] && css(...args)}
`

export default unless
